import axiosInstance from './AxiosInstance';

const API_URL = '/batchreport';

// Per-student batch counts, filterable by department/course, paginated.
export const getStudentBatchReport = async (params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/student-batches`, { params });
  return response.data; // { data, pagination }
};

// Department-wise and course-wise rollups + overall totals.
export const getBatchReportSummary = async () => {
  const response = await axiosInstance.get(`${API_URL}/summary`);
  return response.data.data; // { totals, byDepartment, byCourse }
};

// Groups of batches that look like accidental duplicates (same course +
// trainer + name), for manual review — nothing is auto-merged/deleted.
export const getDuplicateBatches = async () => {
  const response = await axiosInstance.get(`${API_URL}/duplicate-batches`);
  return response.data.data; // { duplicateGroups, totalGroups }
};
